var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#01qao7ygga)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.5s9-8.529 9-15a9 9 0 1 0-18 0c0 6.471 9 15 9 15zM12 14a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "01qao7ygga"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.25da5057198ac2089a86c3cdbf6921b0.svg";
export { ForwardRef as ReactComponent };